<template>
  <div class="w-full px-2">
    <div
      class="p-4 w-full border rounded-md bg-green-500 flex flex-wrap items-center"
    >
    <div class="my-1 flex flex-wrap items-center">
      <div class="">
        <span
 
          ><svg width="20" height="18">
            <g transform="translate(-2 -3)" fill="#ffffff" fill-rule="evenodd">
              <path
                d="M2.47 16.72a.75.75 0 01.976-.073l.084.073L6 19.189l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 010-1.06z"
                fill-rule="nonzero"
              ></path>
              <path
                d="M6 3c.38 0 .693.253.743.582l.007.091v16.175c0 .372-.336.673-.75.673-.38 0-.693-.253-.743-.582l-.007-.091V3.673C5.25 3.301 5.586 3 6 3z"
                fill-rule="nonzero"
              ></path>
              <rect x="10" y="6" width="12" height="2" rx="1"></rect>
              <rect x="13" y="12" width="9" height="2" rx="1"></rect>
              <rect x="16" y="18" width="6" height="2" rx="1"></rect>
            </g></svg
        ></span>
      </div>
      <div class="my-2 px-4 text-white font-bold text-base">Orden:</div>
      <div>
        <div>
          <select @change="cambioFiltro()" class="w-full px-2 py-2  bg-white border " v-model="sortSelected"
            ><option v-for="(item,ind) in sorter" :key="ind" :value="ind"
              >{{ item.label }}</option
            >
            </select
          >
        </div>
      </div>
      </div>
      <div class="my-1 pl-0 sm:pl-4 flex flex-wrap items-center">
      <div class="my-2 pr-4 text-white font-bold text-base">Precio</div>
      <div class="mr-4">
        <div>
          <select @change="cambioFiltro()" class="w-fit px-2 py-2  bg-white border " v-model="prminSelected"
            ><option v-for="(item,ind) in [{type:-1,label:'MIN'},...precios]" :key="ind" :value="item.type"
              >{{ item.label }}</option
            >
            </select
          >
        </div>
      </div>

      <div>
        <div>
          <select @change="cambioFiltro()" class="w-fit px-2 py-2  bg-white border " v-model="prmaxSelected"
            ><option v-for="(item,ind) in [{type:-2,label:'MAX'},...precios]" :key="ind" :value="item.type"
              >{{ item.label }}</option
            >
            </select
          >
        </div>
      </div>

      </div>


      <div class="my-1 pl-0 sm:pl-4 flex flex-wrap items-center">
      <div class="my-2 pr-4 text-white font-bold text-base">Tamaño</div>
      <div class="mr-4">
        <div>
          <select @change="cambioFiltro()" class="w-fit px-2 py-2  bg-white border " v-model="arminSelected"
            ><option v-for="(item,ind) in [{type:-1,label:'MIN'},...areas]" :key="ind" :value="item.type"
              >{{ item.label }}</option
            >
            </select
          >
        </div>
      </div>

      <div>
        <div>
          <select @change="cambioFiltro()" class="w-fit px-2 py-2  bg-white border " v-model="armaxSelected"
            ><option style="padding:5px; height: 30px;" v-for="(item,ind) in [{type:-2,label:'MAX'},...areas]" :key="ind" :value="item.type"
              >{{ item.label }}</option
            >
            </select
          >
        </div>
      </div>

      </div>


    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Filtros",
  props: {
    sort: {
      type: Number,
      default: 0
    },
    prMax: {
      type: Number,
      default: 0
    },
    prMin: {
      type: Number,
      default: 0
    },    
    arMax: {
      type: Number,
      default: 0
    },
    arMin: {
      type: Number,
      default: 0
    },      
    sorter: {
      type: Array,
      default: () => { return [] }
    },
    precios: {
      type: Array,
      default: () => { return [] }
    },
    areas: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function() {
    return {
      sortSelected: this.sort,
      prminSelected: this.prMin,
      prmaxSelected: this.prMax, 
      arminSelected: this.arMin,
      armaxSelected: this.arMax,            
      list: [],
      carouselOptions: {
        name: "gallery",
        width: 200,
        step: 2,
        margin: "auto",
        arrow: "float"
      }
    };
  },
  filters: {
    plural: function(value, text) {
      let s = value + " " + text;
      if (Number(value) > 1) {
        s = s + "s";
      }
      return s;
    },
    renting_period: function(value) {
      if (value === "monthly") return "€/mes";

      return value;
    },
    last_update: function(value) {
      var d1 = new Date();
      var d2 = new Date(value);
      var s = value;
      var dif = d1 - d2;
      dif = dif / (24 * 3600 * 1000);
      if (dif >= 1) {
        s = Math.ceil(dif);
        if (s === 1) s = s + " día";
        if (s > 1) s = s + " días";
      }
      if (dif < 1) {
        var h = Math.floor(dif * 24);
        s = h + " Horas";
      }

      return s;
    }
  },
  
  created() {},

  methods: {
    cambioFiltro() {
      this.$emit('cambio', { 
        sort: this.sortSelected, 
        prmin: this.prminSelected, 
        prmax: this.prmaxSelected, 
        armin: this.arminSelected, 
        armax: this.armaxSelected 
        })
    }
  }
};
</script>
<style lang="postcss" scoped>
.imagen {
  @apply w-full;
  height: 300px;
}

@media (min-width: 640px) {
  .imagen {
    width: 300px;
    height: 300px;
  }
}

@media (min-width: 768px) {
  .imagen {
    width: 400px;
    height: 400px;
  }
}

*,
*:focus,
*:hover {
  outline: none !important;
}

body select { 
    display: block;
    padding: 10px 30px 10px 13px !important; 
    max-width: 100%; 
    height: auto !important; 
    border: 1px solid #e3e3e3; 
    border-radius: 3px; 
    background: url("~@/assets/selectbox-arrow.png") right center no-repeat; 
    background-color: #fff; 
    color: #444444; 
    font-size: 12px; 
    line-height: 16px !important; 
    appearance: none; 
    /* this is must */ -webkit-appearance: none; 
    -moz-appearance: none; 
} 
/* body select.select_box option */ 
body select option { 
    padding: 4px 4px; 
} 
/* for IE and Edge */ 
select::-ms-expand { 
    display: none; 
} 
select:disabled::-ms-expand { 
    background: #f60; 
}
</style>
